import { createSlice } from "@reduxjs/toolkit";
import { userProfileReviewAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const userProfileReviewSlice = createSlice({
  name: "userProfileReview",
  initialState: data,
  reducers: {
    userProfileReviewSlice(state) {
      state.isLoading = true;
    },
    userProfileReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    userProfileReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    userProfileReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const userProfileReviewHandler = (user_id?:string) => async (dispatch: any) => {
  try {
    dispatch(userProfileReviewAction.userProfileReviewSlice());
    const response: any = await userProfileReviewAPI(user_id as string);
    dispatch(userProfileReviewAction.userProfileReviewSliceSuccess(response));
  } catch (e: any) {
    dispatch(userProfileReviewAction.userProfileReviewSliceFailure(e?.response?.data?.message));
    dispatch(userProfileReviewAction.userProfileReviewSliceReset());
  }
};
export default userProfileReviewSlice.reducer;
export const userProfileReviewAction = userProfileReviewSlice.actions;
